import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiInstagram, FiFacebook, FiMail, FiArrowRight, FiPhone, FiCheck } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa';
import toast from 'react-hot-toast';
import api from '../utils/api';
import './Footer.css';

// Store contact number — same one used on ProductDetail / payment info
const CONTACT_NUMBER = '+923111181003';
const WHATSAPP_LINK = `https://wa.me/${CONTACT_NUMBER.replace('+', '')}`;
const CALL_LINK = `tel:${CONTACT_NUMBER}`;

const Footer = () => {
    // NEW: "Join the Club" previously did nothing at all — the form just
    // called e.preventDefault() and stopped. No state, no API call, no
    // backend endpoint even existed to receive it. Now wired up to
    // POST /api/newsletter/subscribe with proper loading/success/error
    // feedback.
    const [newsletterEmail, setNewsletterEmail] = useState('');
    const [subscribing, setSubscribing] = useState(false);
    const [subscribed, setSubscribed] = useState(false);

    const handleNewsletterSubmit = async (e) => {
        e.preventDefault();
        const email = newsletterEmail.trim();

        if (!email) {
            toast.error('Please enter your email address');
            return;
        }

        setSubscribing(true);
        try {
            const res = await api.post('/newsletter/subscribe', { email });
            toast.success(res.data?.message || 'Welcome to the club! 🎉');
            setSubscribed(true);
            setNewsletterEmail('');
        } catch (err) {
            toast.error(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setSubscribing(false);
        }
    };

    return (
        <footer className="footer">
            <div className="footer-blob footer-blob-tr" />
            <div className="footer-blob footer-blob-bl" />

            <div className="container">
                <div className="footer-top">
                    {/* Brand Column */}
                    <div className="footer-brand">
                        <Link to="/" className="footer-logo">Raajdhani</Link>
                        <p className="footer-by">by Sonia</p>
                        <p className="footer-tagline">The Art of Everyday Elegance</p>
                        <div className="footer-socials">
                            <a href="https://instagram.com" target="_blank" rel="noreferrer" className="social-link instagram"><FiInstagram /></a>
                            <a href="https://facebook.com" target="_blank" rel="noreferrer" className="social-link facebook"><FiFacebook /></a>
                            <a href="mailto:support@raajdhani.com" className="social-link email"><FiMail /></a>
                            <a
                                href={CALL_LINK}
                                className="social-link phone"
                                title="Call us"
                                aria-label="Call us"
                            >
                                <FiPhone />
                            </a>
                            <a
                                href={WHATSAPP_LINK}
                                target="_blank"
                                rel="noreferrer"
                                className="social-link whatsapp"
                                title="Chat on WhatsApp"
                                aria-label="Chat on WhatsApp"
                            >
                                <FaWhatsapp />
                            </a>
                        </div>
                    </div>

                    {/* Support Column */}
                    <div className="footer-col">
                        <h4 className="footer-col-title">Support</h4>
                        <ul className="footer-col-list">
                            <li><Link to="/track-order" className="footer-nav-link">Track Order</Link></li>
                            <li><Link to="/support#sizing" className="footer-nav-link">Size Chart</Link></li>
                            <li><Link to="/contact" className="footer-nav-link">Contact Us</Link></li>
                            <li><Link to="/support" className="footer-nav-link">FAQs</Link></li>
                            {/* NEW: folded in from the bottom bar — see Footer.css
                                for the 2-column grid this list now uses on both
                                desktop and mobile. Removed from footer-bottom
                                below to avoid listing them twice. */}
                            <li><Link to="/privacy" className="footer-nav-link">Privacy Policy</Link></li>
                            <li><Link to="/terms" className="footer-nav-link">Terms</Link></li>
                        </ul>
                    </div>

                    {/* Newsletter Column */}
                    <div className="footer-newsletter">
                        <h4 className="footer-col-title">Join the Club</h4>
                        {subscribed ? (
                            <p className="newsletter-sub" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                <FiCheck /> You're on the list — thank you!
                            </p>
                        ) : (
                            <>
                                <p className="newsletter-sub">Be the first to know about new drops and exclusive offers.</p>
                                <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
                                    <input
                                        type="email"
                                        placeholder="Email Address"
                                        className="newsletter-input"
                                        value={newsletterEmail}
                                        onChange={e => setNewsletterEmail(e.target.value)}
                                        disabled={subscribing}
                                        required
                                    />
                                    <button
                                        type="submit"
                                        className="newsletter-btn"
                                        disabled={subscribing}
                                        aria-label="Subscribe"
                                    >
                                        <FiArrowRight />
                                    </button>
                                </form>
                            </>
                        )}
                    </div>
                </div>

                <div className="footer-bottom">
                    <p>&copy; {new Date().getFullYear()} Raajdhani by Sonia. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;